



































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import Tooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import MoreInfoButton from '@/modules/shared/components/shared/table/action/ActionMoreInfoButton.vue'
import ActionMoreInfoButton from '@/modules/shared/components/shared/table/action/ActionMoreInfoButton.vue'
import { ContentItemGetUseCase } from '@/modules/content-item/use-cases/panel/content-item-get.use-case'
import PanelContentItemShowModal from '@/modules/content-item/components/panel/PanelContentItemShowModal.vue'
import NewTicketButton from '@/modules/ticket/components/shared/NewTicketButton.vue'
import PanelContentItemShowContentModal
  from '@/modules/content-item/components/panel/PanelContentItemShowContentModal.vue'
import { ContentItemCollectionModel } from '@/modules/content-item/models/content-item-collection.model'
import ActionShowButtonI from '@/modules/shared/components/shared/table/action/ActionShowButtonI.vue'
import PanelContentItemShowContentButton
  from '@/modules/content-item/components/panel/PanelContentItemShowContentButton.vue'
import { ContentItemStatus } from '@/modules/content-item/models/content-item-resource.model'
import { TicketModelType } from '@/modules/ticket/models/ticket-resource.model'

const showTicketStatuses = [
  ContentItemStatus.PENDING,
  ContentItemStatus.QUEUE,
  ContentItemStatus.REJECTED,
  ContentItemStatus.EDITING
]

const viewButtonStatuses = [
  ContentItemStatus.COMPLETED,
  ContentItemStatus.REJECTED
]

@Component({
  components: {
    PanelContentItemShowContentButton,
    ActionMoreInfoButton,
    ActionShowButtonI,
    PanelContentItemShowContentModal,
    PanelContentItemShowModal,
    MoreInfoButton,
    NewTicketButton,
    Tooltip,
    BaseButton
  }
})
export default class PanelContentItemActions extends Vue {
  constructor(
    private readonly getUseCase: ContentItemGetUseCase
  ) {
    super()
  }

  @Prop() contentItem !: ContentItemCollectionModel
  infoModal = false
  ticketItemType = TicketModelType

  get isLoading() {
    return this.getUseCase.isLoading
  }

  get showTicketButton() {
    return showTicketStatuses.includes(this.contentItem.status)
  }

  get showViewButton() {
    return viewButtonStatuses.includes(this.contentItem.status)
  }

  moreInfo() {
    this.getUseCase.execute(this.contentItem.id)
      .then(value => this.infoModal = true)
  }

}
